// tslint:disable:max-line-length
import { ToolListComponent } from '@app/roles/admin/pages/tools';
import { UsersTableComponent } from './pages/users/users-table/users-table.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


import { SharedModule } from '@app/shared/shared.module';
import { LinesComponent } from '@app/roles/admin/pages/lines/lines.component';
import { PlantService } from '@services/plant.service';
import { RoleService } from '@services/role.service';
import { PlantCreateModalComponent } from '@app/roles/admin/pages/plants/components/plant-create-modal/plant-create-modal.component';
import { PlantsTableComponent } from '@app/roles/admin/pages/plants/components/plants-table/plants-table.component';
import { PlantManagementComponent } from '@app/roles/admin/pages/plants/plants.component';

import { EquipmentService } from '@app/core/services/equipment.service';
import { LineCreateModalComponent } from "@app/roles/admin/pages/lines/components/line-create-modal/line-create-modal.component";
import { LinesTableComponent } from "@app/roles/admin/pages/lines/components/lines-table/lines-table.component";
import { LineService } from "@app/core/services/line.service";
import { RolesComponent } from '@app/roles/admin/pages/roles/roles.component';
import { RolesTableComponent } from '@app/roles/admin/pages/roles/components/roles-table/roles-table.component';
import { RolesModalComponent } from '@app/roles/admin/pages/roles/components/roles-modal/roles-modal.component';
import { UserListComponent } from "@app/roles/admin/pages/users";
import { EquipmentManagementComponent } from "@app/roles/admin/pages/equipment/equipment.component";
import { EquipmentTableComponent } from "@app/roles/admin/pages/equipment/components/equipment-table/equipment-table.component";
import { RouterModule } from "@angular/router";
import { ToolHistoryService } from "@services/tool-history.service";
import { ProcessTypeService } from "@services/process-type.service";
import { ToolHistoryComponent } from "@app/roles/admin/pages/tool-history/tool-history.component";
import { StatusHistoryComponent } from "@app/roles/admin/pages/tool-history/components/status-history/status-history.component";
import { ToolModule } from "@app/tool/tool.module";
import { PartNumberManagementComponent } from "@app/roles/admin/pages/partnumbers/partnumber.component";
import { PartNumbersService } from "@services/part-numbers.service";
import {
    PartNumberModalComponent,
    PartNumberTableComponent
} from "@app/roles/admin/pages/partnumbers/components";
import {
    EquipmentCreateModalComponent,
} from "@app/roles/admin/pages/equipment/components";
import {
    LifecycleHistoryComponent,
    LifecycleHistoryTableComponent,
    StatusHistoryTableComponent
} from "@app/roles/admin/pages/tool-history/components";
import { IssuesComponent } from './pages/issues/issues.component';
import { IssuesService } from "@services/issues.service";
import { ReasonsService } from "@services/reasons.service";
import { IssueCreateModalComponent } from './pages/issues/components/issue-create-modal/issue-create-modal.component';
import { ReasonsComponent } from './pages/issues/components/reasons/reasons.component';
import { ReasonsTableComponent } from '@app/roles/admin/pages/issues/components/reasons/components';
import { ReasonsCreateModalComponent } from "@app/roles/admin/pages/issues/components/reasons/components";
import { TicketManagementComponent } from '@app/roles/admin/pages/ticket-management/tickets.component';
import {
    TicketsTableComponent
} from "@app/roles/admin/pages/ticket-management/components";
import { TicketService } from "@services/ticket.service";
import { OperationTypeService } from "@services/operation-type.service";
import { OperationTypesComponent } from '@app/roles/admin/pages/ticket-management/components';
import {
    OperationTypesModalComponent,
    OperationTypesTableComponent
} from "@app/roles/admin/pages/ticket-management/components/operation-types/components";
import { AdminToolsTableComponent } from "@app/roles/admin/pages/tools";
import { PermissionService } from "@app/authentication/services/permission.service";
import { AuditsComponent } from './pages/audits-management/audits.component';
import { AuditsService } from "@services/audits.service";
import { AuditsTableComponent } from './pages/audits-management/components/audits-table/audits-table.component';
import { AuditsFormComponent } from './pages/audits-management/components/audits-form/audits-form.component';
import { ToolReturnHistoryComponent } from '@app/roles/admin/pages/request-history/components';
import { ToolRequestHistoryComponent } from '@app/roles/admin/pages/request-history/components';
import {
    ToolRequestHistoryTableComponent
} from '@app/roles/admin/pages/request-history/components';
import {
    ToolReturnHistoryTableComponent
} from '@app/roles/admin/pages/request-history/components';
import { RequestHistoryComponent } from './pages/request-history/request-history.component';
import { InsertionCyclesComponent } from './pages/insertion-cycles/insertion-cycles.component';
import { InsertionCyclesService } from '@app/core/services/insertion-cycles.service';
import { InsertionCyclesTableComponent } from './pages/insertion-cycles/components/insertion-cycles-table/insertion-cycles-table.component';

import {
    InsertionCyclesCreateModalComponent
} from './pages/insertion-cycles/components/insertion-cycles-create-modal/insertion-cycles-create-modal.component';
import { RequestHistoryService } from "@services/request-history.service";
import {
    PartNumberLinesFormComponent
} from '@app/roles/admin/pages/partnumbers/components/partnumber-modal/forms/part-number-lines-form/part-number-lines-form.component';
import {
    PartNumberInsertionCyclesFormComponent
} from '@app/roles/admin/pages/partnumbers/components/partnumber-modal/forms/part-number-insertion-cycles-form/part-number-insertion-cycles-form.component';
import {
    PartNumberEquipmentFormComponent
} from '@app/roles/admin/pages/partnumbers/components/partnumber-modal/forms/part-number-equipment-form/part-number-equipment-form.component';
import {
    PartNumberDetailsFormComponent
} from '@app/roles/admin/pages/partnumbers/components/partnumber-modal/forms/part-number-details-form/part-number-details-form.component';
import {
    LineDetailsFormComponent
} from '@app/roles/admin/pages/lines/components/line-create-modal/line-details-form/line-details-form.component';
import {
    LineInsertionCyclesFormComponent
} from '@app/roles/admin/pages/lines/components/line-create-modal/line-insertion-cycles-form/line-insertion-cycles-form.component';
import {
    LineEquipmentFormComponent
} from '@app/roles/admin/pages/lines/components/line-create-modal/line-equipment-form/line-equipment-form.component';
import { ToolUsageComponent } from '@app/roles/admin/pages/tools-usage';
import { ToolsUsageTableComponent } from '@app/roles/admin/pages/tools-usage';
import { LiftsModule } from '@app/lift/lifts.module';
import {
    PartNumberToolsFormComponent
} from '@app/roles/admin/pages/partnumbers/components/partnumber-modal/forms/part-number-tools-form/part-number-tools-form.component';
import { PartnumberOverviewComponent } from '@app/roles/admin/pages/partnumbers/components/partnumber-overview/partnumber-overview.component';
import {
    PartNumberToolsTableComponent
} from '@app/roles/admin/pages/partnumbers/components/part-number-tools-table/part-number-tools-table.component';
import {
    PartNumberEquivalenceFormComponent
} from '@app/roles/admin/pages/partnumbers/components/partnumber-modal/forms/part-number-equivalence-form/part-number-equivalence-form.component';
import {
    DocumentsLocationConfirmationModalComponent
} from '@app/roles/admin/pages/plants/components/documents-location-confirmation-modal/documents-location-confirmation-modal.component';
import { MaintenanceModule } from '@app/maintenance/maintenance.module';
import { AdminTicketComponent } from './pages/ticket-management/components/admin-ticket/admin-ticket.component';
import { DynamicDialogModule } from "primeng/dynamicdialog";
import { ProcessTypesManagementComponent } from "@app/roles/admin/pages/process-types/process-types.component";
import {
    ProcessTypesTableComponent
} from "@app/roles/admin/pages/process-types/components/process-types-table/process-types-table.component";
import {
    ProcessTypeCreateModalComponent
} from "@app/roles/admin/pages/process-types/components/process-type-create-modal/process-type-create-modal.component";

import { RecurrenceModalComponent } from './pages/tools-usage/components/recurrence-modal/recurrence-modal.component';
import { LineTransportSettingsFormComponent } from './pages/lines/components/line-create-modal/line-transport-settings-form/line-transport-settings-form.component';

import { ValueStreamManagementComponent } from './pages/value-streams/value-streams.component';
import { ValueStreamTableComponent } from './pages/value-streams/components/value-streams-table/value-streams-table.component';
import { ValueStreamService } from '@app/core/services/value-stream.service';
import { ValueStreamCreateModalComponent } from './pages/value-streams/components/value-stream-create-modal/value-stream-create-modal.component';
import { InternalPositionService } from '@app/core/services/internal-position.service';
import { UserDetailsModalComponent } from '@app/roles/admin/pages/users/components/user-details-modal/user-details-modal.component';
import { RegisterEmdUserModalComponent } from '@app/roles/admin/pages/users/components/register-emd-user-modal/register-emd-user-modal.component';

@NgModule({
    declarations: [
        UsersTableComponent,
        UserDetailsModalComponent,
        RegisterEmdUserModalComponent,
        LinesComponent,
        LineCreateModalComponent,
        LinesTableComponent,
        PlantCreateModalComponent,
        PlantsTableComponent,
        RolesTableComponent,
        RolesModalComponent,
        UserListComponent,
        ToolListComponent,
        PlantManagementComponent,
        RolesComponent,
        EquipmentManagementComponent,
        EquipmentTableComponent,
        EquipmentCreateModalComponent,
        ProcessTypesManagementComponent,
        ProcessTypesTableComponent,
        ProcessTypeCreateModalComponent,
        ToolHistoryComponent,
        StatusHistoryComponent,
        StatusHistoryTableComponent,
        LifecycleHistoryComponent,
        LifecycleHistoryTableComponent,
        PartNumberManagementComponent,
        PartNumberTableComponent,
        PartNumberModalComponent,
        IssuesComponent,
        IssueCreateModalComponent,
        ReasonsComponent,
        ReasonsTableComponent,
        ReasonsCreateModalComponent,
        TicketManagementComponent,
        TicketsTableComponent,
        OperationTypesComponent,
        OperationTypesTableComponent,
        OperationTypesModalComponent,
        AdminToolsTableComponent,
        ToolsUsageTableComponent,
        AuditsComponent,
        AuditsTableComponent,
        AuditsFormComponent,
        ToolReturnHistoryComponent,
        ToolRequestHistoryComponent,
        ToolRequestHistoryTableComponent,
        ToolReturnHistoryTableComponent,
        RequestHistoryComponent,
        InsertionCyclesComponent,
        InsertionCyclesTableComponent,
        InsertionCyclesCreateModalComponent,
        PartNumberLinesFormComponent,
        PartNumberInsertionCyclesFormComponent,
        PartNumberEquipmentFormComponent,
        PartNumberDetailsFormComponent,
        LineDetailsFormComponent,
        LineInsertionCyclesFormComponent,
        LineTransportSettingsFormComponent,
        LineEquipmentFormComponent,
        ToolUsageComponent,
        PartNumberToolsFormComponent,
        PartnumberOverviewComponent,
        PartNumberToolsTableComponent,
        PartNumberEquivalenceFormComponent,
        DocumentsLocationConfirmationModalComponent,
        AdminTicketComponent,
        RecurrenceModalComponent,
        ValueStreamManagementComponent,
        ValueStreamTableComponent,
        ValueStreamCreateModalComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        RouterModule,
        ToolModule,
        LiftsModule,
        DynamicDialogModule,
        MaintenanceModule
    ],
    exports: [
        PlantCreateModalComponent
    ],
    providers: [
        RoleService,
        ToolHistoryService,
        PlantService,
        LineService,
        EquipmentService,
        ProcessTypeService,
        TicketService,
        OperationTypeService,
        PermissionService,
        PartNumbersService,
        IssuesService,
        InsertionCyclesService,
        ReasonsService,
        AuditsService,
        RequestHistoryService,
        ValueStreamService,
        InternalPositionService
    ],
    bootstrap: []
})

export class AdminModule {
}
